/**
 * Created by mh on 2017/5/24.
 */
import React from 'react';
import PropTypes from 'prop-types';
import { inject, observer } from 'mobx-react';
import { Route, Redirect } from 'react-router-dom';

import Spinner from '../Components/Spinner';
// TODO why redirect not working every time but only once logout ?

// @inject('auth') @observer
// export default class PrivateRoute extends React.Component {
//     render() {
//         const { auth, component: ComponentClass, ...rest } = this.props;
//         // console.log(`PrivateRoute auth for path ${this.props.path}`, auth ? auth.isLoggedIn : 'no auth', auth ? auth.isLoggingIn : 'no auth');
//         return (<Route
//             {...rest}
//             render={props => (
//                 auth && auth.isLoggedIn && !auth.isLoggingIn ? (
//                     <ComponentClass {...props} />
//                 ) : (
//                     auth && !auth.isLoggingIn ? <Redirect
//                         to={{
//                             pathname: '/login',
//                             state: { from: props.location },
//                         }} /> : null
//                 )
//             )} />);
//     }
// }
// PrivateRoute.wrappedComponent.propTypes = {
//     auth: PropTypes.object.isRequired,
//     component: PropTypes.func.isRequired,
// };

const PrivateRoute = ({ auth, name, component: Component, ...rest }) => (
    <Route
        {...rest}
        render={(props) => {
            console.log('PrivateRoute. Is LoggedIn:', auth.isLoggedIn, 'LoggingIn', auth.isLoggingIn, 'Name', name);
            return auth.isLoggedIn && !auth.isLoggingIn ? (
                <Component {...props} />
            ) : !auth.isLoggingIn ? (
                <Redirect
                    to={{
                        pathname: '/login',
                        state: { from: props.location },
                    }}
                />
            ) : <Spinner />;
        }}
    />
);
export default inject('auth')(observer(PrivateRoute));
